export const fontSizes = {
  xs: "0.625rem",
  sm: "0.75rem",
  md: "0.875rem",
  lg: "1rem",
  xl: "1.125rem",
  "2xl": "1.25rem",
  "3xl": "1.375rem",
  "4xl": "1.5rem",
  "5xl": "1.75rem",
  "6xl": "2rem",
  "7xl": "2.25rem",
};
